// wartet, bis das DOM geladen ist
document.addEventListener('DOMContentLoaded', function() {
  // alle Menüeinträge mit Dropdown ermitteln (anpassen, falls Ihr Theme andere Klassen verwendet)
  var parentMenuItems = document.querySelectorAll('div.menu__item.parent');
  parentMenuItems.forEach(function(menuItem) {
    // nur der Top-Level-Link soll beim Klick navigieren
    var topLink = menuItem.querySelector('a.navlink--toplevel, a[data-top-link]');
    if (!topLink) {
      return;
    }

    topLink.addEventListener('click', function(event) {
      event.preventDefault();
      event.stopPropagation();
      window.location.href = topLink.href;
    });
  });

  /* Desktop Brands search filter + A-Z jump */
  document.querySelectorAll('[data-hos-brands-desktop]').forEach(function(wrap) {
    var filterInput = wrap.querySelector('[data-hos-brands-filter]');
    var list = wrap.querySelector('[data-hos-brands-list]');
    var azBar = wrap.querySelector('[data-hos-brands-az-bar]');
    var emptyMsg = wrap.querySelector('[data-hos-brands-empty]');
    if (!filterInput || !list) return;

    filterInput.addEventListener('input', function() {
      var q = filterInput.value.toLowerCase().trim();
      var items = list.querySelectorAll('[data-brand-name]');
      var headings = list.querySelectorAll('[data-hos-brands-group]');
      var visibleCount = 0;

      items.forEach(function(item) {
        var show = !q || item.getAttribute('data-brand-name').indexOf(q) !== -1;
        if (show) { item.removeAttribute('hidden'); visibleCount++; }
        else { item.setAttribute('hidden', ''); }
      });

      headings.forEach(function(h) {
        var letter = h.getAttribute('data-hos-brands-group');
        var hasVisible = list.querySelector('[data-brand-letter="' + letter + '"]:not([hidden])');
        h.style.display = hasVisible ? '' : 'none';
      });

      if (azBar) azBar.style.display = q ? 'none' : '';
      if (emptyMsg) {
        if (visibleCount === 0 && q) emptyMsg.removeAttribute('hidden');
        else emptyMsg.setAttribute('hidden', '');
      }
    });

    if (azBar) {
      azBar.addEventListener('click', function(e) {
        var btn = e.target.closest('[data-hos-brands-jump]');
        if (!btn) return;
        var letter = btn.getAttribute('data-hos-brands-jump');
        var target = list.querySelector('[data-hos-brands-group="' + letter + '"]');
        if (target) list.scrollTo({ top: target.offsetTop, behavior: 'smooth' });
        azBar.querySelectorAll('.hos-brands-desktop__az-btn').forEach(function(b) {
          b.classList.toggle('is-active', b === btn);
        });
      });
    }
  });
}); 